<template>
  <div class="report-container" style="background-color: #2B2D33!important;">
    <v-card>
      <!-- <v-card-title class="text-h5 font-weight-bold primary--text">
        集团报表
      </v-card-title> -->
      <!-- <v-card-text> -->
        
        <div class="title-bg" style="margin-bottom: 16px;">集团报表</div>
        <div style="background-color: #2B2D33!important;border: 1px solid rgba(255, 255, 255, 0.12) !important;">
          <v-img
            src="./src/assets/chapt.jpg"
            alt="报表图片"
            class="bgImg"
            contain
          />
          <!-- <v-card-subtitle class="text-h6 mt-4">
            报表数据加载中...
          </v-card-subtitle> -->
        </div>
      <!-- </v-card-text> -->
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'

// 页面标题
document.title = '集团报表'

onMounted(() => {
  console.log('报表页面已加载')
})
</script>

<style lang="scss" scoped>
.report-container {
  padding: 20px;
  min-height: calc(100vh - 120px);
  background: #2B2D33!important;
}

.report-container :deep(.v-card) { 
  background: #2B2D33!important;
}

.v-card {
  /* box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1); */
}

.bgImg{
    width: 1400px;
    /* border-radius: 8px; */
}
</style> 